import React from 'react'
import { Control, Controller, RegisterOptions } from 'react-hook-form'
import classNames from 'classnames'

type Props = {
  name: string
  label: string
  control?: Control<any>
  rules?: RegisterOptions
  value: string | number
  disabled?: boolean
  width?: string
}

const VehicleSuggestionCard = ({
  name,
  label,
  value,
  control,
  rules,
  disabled,
  width,
}: Props) => {
  const className = classNames(
    `flex w-full flex-col gap-2 bg-primary-persian-blue/10 rounded-xl p-3 border-2 border-primary-persian-blue/5 peer-checked:border-primary-persian-blue peer-checked:bg-white peer-checked:shadow-2xl`,
    {
      'cursor-pointer': !disabled,
      'text-web-gray cursor-not-allowed': disabled,
    },
  )

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <div className={'flex'}>
          <input
            {...field}
            type="checkbox"
            id={`${name}-${value}`}
            name={name}
            value={value}
            disabled={disabled}
            className="hidden peer"
          />
          <label htmlFor={`${name}-${value}`} className={className}>
            <span className={'text-xs'}>{label}</span>
            <span className={'font-bold'}>{value}</span>
          </label>
        </div>
      )}
    />
  )
}

export default VehicleSuggestionCard
